import React from 'react';
// Layout component with premium noXt networking header
import { Link } from 'react-router-dom';
import { useI18n, Lang } from '@/lib/i18n';
import { ROUTE_PATHS } from '@/lib/index';

const FlagPT = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 14" className="w-8 h-[22px] rounded shadow-sm">
    <rect width="8" height="14" fill="#006600"/>
    <rect x="8" width="12" height="14" fill="#FF0000"/>
    <ellipse cx="8" cy="7" rx="3" ry="3.5" fill="#FFFF00" stroke="#FF0000" strokeWidth="0.4"/>
    <ellipse cx="8" cy="7" rx="1.8" ry="2.1" fill="#0000AA"/>
    <line x1="6.2" y1="5.5" x2="9.8" y2="5.5" stroke="white" strokeWidth="0.5"/>
    <line x1="6.2" y1="8.5" x2="9.8" y2="8.5" stroke="white" strokeWidth="0.5"/>
  </svg>
);

const FlagES = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 14" className="w-8 h-[22px] rounded shadow-sm">
    <rect width="20" height="14" fill="#AA151B"/>
    <rect y="3.5" width="20" height="7" fill="#F1BF00"/>
  </svg>
);

export default function Layout({ children }: { children: React.ReactNode }) {
  const { lang, setLang, t } = useI18n();

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white border-b border-border/60">
        <div className="max-w-6xl mx-auto px-5 h-16 flex items-center justify-between">

          {/* Brand */}
          <Link to={ROUTE_PATHS.HOME} className="flex items-center gap-3 group">
            <div className="flex flex-col leading-none">
              <span className="text-[15px] font-bold tracking-tight text-foreground group-hover:text-primary transition-colors">
                no<span className="text-primary">X</span>t networking
              </span>
              <span className="text-[10px] font-medium text-muted-foreground tracking-wider uppercase mt-0.5">
                {t('appSub')}
              </span>
            </div>
          </Link>

          {/* Divisor + Contera */}
          <div className="hidden sm:flex items-center gap-2 text-[11px] text-muted-foreground font-medium">
            <span className="h-4 w-px bg-border" />
            <span>Contera</span>
          </div>

          {/* Seletor de língua */}
          <div className="flex items-center gap-1.5 ml-auto sm:ml-0 sm:pl-4">
            {(['pt', 'es'] as Lang[]).map((l) => (
              <button
                key={l}
                onClick={() => setLang(l)}
                title={l === 'pt' ? 'Português' : 'Español'}
                className={`rounded transition-all duration-200 p-0.5 ${
                  lang === l
                    ? 'ring-2 ring-primary ring-offset-1 scale-110'
                    : 'opacity-70 hover:opacity-100 hover:scale-105'
                }`}
              >
                {l === 'pt' ? <FlagPT /> : <FlagES />}
              </button>
            ))}
          </div>
        </div>
      </header>

      {/* Main */}
      <main className="flex-1">
        {children}
      </main>

      {/* Footer */}
      <footer className="border-t border-border/60 bg-white py-4">
        <div className="max-w-6xl mx-auto px-5 text-center text-[11px] text-muted-foreground font-medium tracking-wide">
          {t('footer')}
        </div>
      </footer>
    </div>
  );
}
